export default __webpack_public_path__ + "static/media/logos.2dd10a2d.svg";